import throttle from 'lodash/throttle';
import { history } from '../Store';
import Axios from 'axios';
import CONFIG from '../config';
import { loadScriptAsync } from '.';

/**
 * Initilialise Google tag manager for analytics & setup for tracking pages
 */

const ANALYTICS_GA_ID = 'UA-133653258-1';
const AW_GA_ID = 'AW-449769229';

export const initReactGA = async () => {
  try {
    if (window.location.hostname === 'log2base2.com' || window.location.hostname === 'www.log2base2.com') {
      // Load Google Tag Manager
      await loadScriptAsync(`https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_GA_ID}`);
      window.dataLayer = window.dataLayer || [];
      const ReactGA = function() {
        window.dataLayer.push(arguments);
      };
      window.ReactGA = ReactGA;

      // Initialise Gtag
      ReactGA('js', new Date());
      ReactGA('config', ANALYTICS_GA_ID);
      ReactGA('config', AW_GA_ID);

      // Initialise Page tracking
      initGAPageViewTrack();
    }
  } catch (err) {
    console.log('GA Init Failed');
  }
};

const trackPageView = (pathname, searchKey = '') => {
  window.ReactGA('config', ANALYTICS_GA_ID, {
    page_path: pathname + searchKey,
  });
  mapConversionTrack(pathname);
};

const initGAPageViewTrack = () => {
  trackPageView(window.location.pathname, window.location.search);
  history.listen((location) => {
    trackPageView(location.pathname, location.search);
  });
};

const mapConversionTrack = (pageItem) => {
  try {
    const trackGAPageValue = (itemID, value) => {
      window.ReactGA('event', 'view_item', {
        send_to: AW_GA_ID,
        value: value,
        items: [
          {
            id: itemID,
            google_business_vertical: 'education',
          },
        ],
      });
    };

    // Maps Route to the Key and Cost Value
    if (pageItem === '/') trackGAPageValue('HOME', '4999');
    else if (pageItem.includes('/dsa')) trackGAPageValue('DSA', '2999');
    else if (pageItem.includes('/dsa-java')) trackGAPageValue('DSAJAVA', '1999');
    else if (pageItem.includes('/problem-solving-beginners')) trackGAPageValue('PBSBEG', '1499');
    else if (pageItem.includes('/problem-solving-with-dsa')) trackGAPageValue('PBSDSA', '1999');
    else if (pageItem.includes('/python')) trackGAPageValue('PYTHONPROGRAM', '1499');
    else if (pageItem.includes('/c-programming')) trackGAPageValue('CPROGRAM', '1999');
    else if (pageItem.includes('/students')) trackGAPageValue('STUDENT', '3999');
    else if (pageItem.includes('/dashboard')) trackGAPageValue('DASHBOARD', '25');
    else if (/\/courses\/.*\/.*/.test(pageItem)) trackGAPageValue('LEARNING', '50');
    else if (pageItem.includes('/pricing')) trackGAPageValue('PRICING', '75');
    else if (pageItem.includes('/checkout')) trackGAPageValue('CHECKOUT', '100');
    else if (pageItem.includes('/courses/recursion')) trackGAPageValue('RECURSION', '100');
    else if (pageItem.includes('/interview')) trackGAPageValue('INTERVIEW', '100');
    else if (pageItem.includes('/courses/bitwise-for-coding-interview')) trackGAPageValue('BITWISE', '100');
    else if (pageItem.includes('courses/dynamic-programming')) trackGAPageValue('DYNAMIC', '100');
    else if (pageItem.includes('/tamil')) trackGAPageValue('L2B2TAMIL', '999');
    else if (pageItem.includes('/hindi')) trackGAPageValue('L2B2HINDI', '999');
    else if (pageItem.includes('/telugu')) trackGAPageValue('L2B2TELUGU', '999');
  } catch (err) {
    console.log('Unable to send page value');
  }
};

const userLog = () => {
  logApi();
  history.listen(throttle(logApi, 2500));
};

function logApi(location) {
  const username = localStorage.getItem('currentUser');
  location = location ? location.pathname : window.location.pathname + window.location.search;

  if (username) {
    const request = {
      user: username,
      event: 'page-navigation',
      data: {
        url: location,
      },
    };

    let eventProperties = {
      url: location,
    };
    Axios.post(CONFIG.apiURL + `/log`, request);
  }
}

export default userLog;
